"use client";

import { createContext } from "react";

export type SessionPermissionsState = {
  permissions: string[];
  isLoading: boolean;
};

export const SessionPermissionsContext =
  createContext<SessionPermissionsState | null>(null);
